import { Button, Col, Dropdown, Form, Menu, message, Modal, notification, Row, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import liracrypt from './Liracrypt/liracrypt';
import { useLocation } from 'react-router-dom/';
import queryString from 'query-string';
import ApiErrorComp from './ApiErrorComp/ApiErrorComp';
import ZenFormInput from '../pages/InputCreater/ZenFormInput';
import { DashOutlined, LoadingOutlined, MoreOutlined } from "@ant-design/icons";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import dayjs from 'dayjs';
import MultiText from './MultiText';
import ZenModal from './ZenModal';
import { useSelector } from 'react-redux';
import { createRoute } from '../utils/CustomFunc';
import noImg from '../assets/static/noImg.jpeg';
import MultiTextDynamic from './MultiTextDynamic';
import FooterButtons from './STORM/FooterButtons';
import HModal from '../pages/HModal';
// import { RiDragMove2Line } from 'react-icons/ri';

const SortableList = ({
    api,
    urlData,
    data,
    pageConfig,
    setPageHeader
}) => {
    const [selectedButton, setSelectedButton] = useState();
    const [isHModalVisible, setIsHModalVisible] = useState(false);
    const [action, setAction] = useState({});

    const { search } = useLocation();
    const searchParams = queryString.parse(search);
    const [selectedItems, setSelectedItems] = useState([]);
    const [config, setConfig] = useState()
    const [pageLoading, setPageLoading] = useState(true);
    const [items, setItems] = useState();
    const [draggingItem, setDraggingItem] = useState(null);
    const urlCode = useSelector(state => state.urlCode);
    const [zenModal, setZenModal] = useState();
    const [modal, setModal] = useState({
        // type: props.config.zenModal.typ,
        type: "kanban",
        data: undefined,
        show: false,
        loading: false,
    });

    const onEditFinish = () => {
        getData();
    }
    const toggleModal = ({ show = false, data = undefined, type = '', loading = false }) => {
        setModal({ show, data, type, loading });
    }

    const zenPopupAction = (zenPopup, value, record) => {
        let urlData = { ...searchParams, ...zenPopup.params };
        if (zenPopup?.props) {
            urlData[zenPopup?.props] = value;
        }
        if (zenPopup?.multiProps) {
            zenPopup?.multiProps.forEach((prop) => {
                urlData[prop] = record[prop];
            });
        }
        if (zenPopup?.typ === 'smodal') {
            toggleModal({
                loading: false,
                show: true,
                data: {
                    id: value,
                    urlData: { ...urlData, ...record.doc }
                },
                type: zenPopup?.typ
            });
            return;
        };
        if (zenPopup?.typ === 'route') {
            toggleModal({
                loading: false,
                show: true,
                data: {
                    route: zenPopup?.route,
                    urlData
                },
                type: zenPopup?.typ
            });
            return;
        }
        if (zenPopup?.api) {
            toggleModal({ show: true, loading: true, type: zenPopup?.typ });
            liracrypt.get(`${zenPopup?.api}`, urlData).then(response => {
                toggleModal({
                    show: true,
                    data: (zenPopup?.typ === 'image' && response?.data?.isSuccess === false) ? noImg : response?.data?.data,
                    loading: false,
                    type: zenPopup?.typ
                })
            });
            return;
        }
    }

    const onConfirmation = ({ popData, urlData = {}, resolve, reject }) => {
        if (popData.method === 'GET') {
            liracrypt.get(popData?.api, urlData)
                .then(response => {
                    message.success(response.data.message || 'Successfull');
                    // if (popData?.editDoc) {
                    //     let data = [...tblConfig.data];
                    //     let updateIndex = data.findIndex(x => x._id === response.data.data._id);
                    //     data[updateIndex] = response.data.data
                    //     setTblConfig({
                    //         ...tblConfig,
                    //         data
                    //     })
                    // }
                    resolve();
                }).catch(err => {
                    ApiErrorComp('Oops Something went wrong');
                    reject();
                })
        }
        if (popData.method === 'POST') {
            liracrypt.post(popData?.api, urlData)
                .then(response => {
                    message.success(response.data.message || 'Successfull');
                    // if (popData?.editDoc) {
                    //     let data = [...tblConfig.data];
                    //     let updateIndex = data.findIndex(x => x._id === response.data.data._id);
                    //     data[updateIndex] = response.data.data
                    //     setTblConfig({
                    //         ...tblConfig,
                    //         data
                    //     })
                    // }
                    resolve();
                }).catch(err => {
                    console.log(err);
                    ApiErrorComp('Oops Something went wrong');
                    reject();
                })
        }
        if (popData.method === 'PATCH') {
            liracrypt.patch(popData?.api, urlData)
                .then(response => {
                    message.success(response.data.message || 'Successfull');
                    // if (popData?.editDoc) {
                    //     let data = [...tblConfig.data];
                    //     let updateIndex = data.findIndex(x => x._id === response.data.data._id);
                    //     data[updateIndex] = response.data.data
                    //     setTblConfig({
                    //         ...tblConfig,
                    //         data
                    //     })
                    // }
                    resolve();
                }).catch(err => {
                    ApiErrorComp('Oops Something went wrong');
                    reject();
                })
        }
        if (popData.method === 'DELETE') {
            liracrypt.delete(popData?.api, urlData)
                .then(response => {
                    message.success(response.data.message || 'Successfull');
                    // if (popData?.editDoc) {
                    //     let data = [...tblConfig.data];
                    //     let updateIndex = data.findIndex(x => x._id === response.data.data._id);
                    //     data[updateIndex] = response.data.data
                    //     setTblConfig({
                    //         ...tblConfig,
                    //         data
                    //     })
                    // }
                    resolve();
                }).catch(err => {
                    ApiErrorComp('Oops Something went wrong');
                    reject();
                })
        }
    }

    const onColumnClick = (record, zenPop) => {
        if (zenPop) {
            let zenPopDataIndex = { ...zenPop };
            setZenModal(zenPopDataIndex);
            if (zenPopDataIndex?.typ === 'newTab') {
                let zenParams = { ...searchParams, ...zenPopDataIndex.params };
                if (zenPopDataIndex?.api) {
                    zenParams.api = zenPopDataIndex?.api;
                }
                let route = createRoute({
                    props: zenPopDataIndex?.props,
                    record,
                    multiProps: zenPopDataIndex?.multiProps,
                    params: { ...zenParams },
                    urlCode,
                    route: zenPopDataIndex?.urlType === 'dynamic' ? record[zenPopDataIndex?.urlKey] : zenPopDataIndex?.route
                });
                window.open(route, '_blank')
                return;
            };

            if (zenPopDataIndex?.typ === 'confirmationPopUp') {
                let urlData = { ...searchParams, ...zenPopDataIndex?.onOk?.params };
                if (zenPopDataIndex?.onOk?.multiProps) {
                    zenPopDataIndex?.onOk?.multiProps.forEach((prop) => {
                        urlData[prop] = record[prop];
                    });
                };
                if (zenPopDataIndex?.onOk?.props) {
                    urlData[zenPopDataIndex?.onOk?.props] = record[zenPopDataIndex?.onOk?.props];
                }

                Modal.confirm({
                    title: zenPopDataIndex?.text,
                    okText: zenPopDataIndex?.okButtonText,
                    cancelText: zenPopDataIndex?.cancelButtonText,
                    onOk: () => {
                        return new Promise((resolve, reject) => {
                            onConfirmation({
                                popData: zenPopDataIndex?.onOk,
                                resolve,
                                reject,
                                urlData
                            });
                        }).catch(() => console.log('Oops errors!'));
                    }
                });
                return;
            }
            zenPopupAction(zenPopDataIndex, record[zenPopDataIndex?.props], record)

        }
    }

    const handleDragStart = (e, item) => {
        setDraggingItem(item);
        e.dataTransfer.setData('text/plain', '');
    };

    const handleDragEnd = () => {
        setDraggingItem(null);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const selectItem = (e, item) => {
        if (e.ctrlKey || e.metaKey) {
            if (checkItemInBag(item)) {
                setSelectedItems(selectedItems.filter(x => x._id !== item._id));
            } else {
                setSelectedItems([...selectedItems, item]);
            }
            // } else {
            //     onColumnClick(item);
        }
    }

    const groupItems = () => {
        liracrypt.post('/test', { items: selectedItems })
            .then(({ data }) => {
                if (data.isSuccess) {
                    message.success(data.message || 'Successfull');
                    setSelectedItems([]);
                    if (data.data) {
                        setItems(data.data);
                    }
                } else {
                    message.error(data.message || 'Error');
                }
            }).catch(err => {
                ApiErrorComp();
            })
    }

    const getData = () => {
        liracrypt.get(api, { ...searchParams, ...urlData })
            .then(({ data }) => {
                if (data.isSuccess) {
                    setItems(data.data);
                    setConfig(data.config);
                    setPageLoading(false);
                    if (setPageHeader) {
                        setPageHeader(data.config.pageTitle);
                    }
                } else {
                    message.error(data.message);
                }
            }).catch(err => {
                console.log(err);
                ApiErrorComp();
            })
    };

    const downloadDocs = (btn) => {
        // let button = btn || selectedButton;
        // if (selectedRowData.length <= 0) return;
        // selectedRowData.forEach(x => {
        //     let urlData = {...searchParams, ...formData, ...btn.fileDownload.params };
        //     if (btn.fileDownload.props) {
        //         urlData[btn.fileDownload.props] = x[btn.fileDownload.props];
        //     }
        //     urlData['token'] = localStorage.getItem("token");
        //     urlData['urlCode'] = urlCode;
        //     let searchParams = new URLSearchParams(urlData);
        //     document.getElementById('downloadLink').setAttribute("href", `${process.env.REACT_APP_API_ENDPOINT}${btn.fileDownload.api}?${searchParams}`);
        //     document.getElementById('downloadLink').click();
        // })
    }

    const finalAction = (action, res) => {
        if (action === "refreshPhantom") {
            notification.success({
                message: res?.data?.message
                    ? res?.data?.message
                    : "Data Modified Successfully !",
            });
            setTimeout(() => {
                window.location.reload();
            }, 2000);
        } else if (action === "refreshStable") {
            document.getElementById("submitButtonForm").click();
        } else {
            notification.success({
                message: res?.data?.message
                    ? res?.data?.message
                    : "Data Modified Successfully !",
            });
        }
    };

    const onResponse = ({ button, onlyPostSubmitAction, response }) => {

        // setStormResponse(data);
        let btnData = button || selectedButton;
        if (btnData.buttonProp?.popUpModal && !onlyPostSubmitAction) {
            return openPopupModal(btnData);
        };
        if (!btnData?.buttonProp?.postSubmitAction) {
            return;
        };
        // if (btnData?.postSubmitActionProp?.action === "clearForm") {
        //   form.resetFields();
        //   console.log("resetFields33");
        // }
        // if (btnData?.postSubmitActionProp?.action === "blankPage") {
        //   setStormResponse(null);
        // };
        let __urlData = { ...searchParams, ...btnData?.postSubmitActionProp?.params };
        if (btnData?.postSubmitActionProp?.action === "reloadStorm") {
            return document.getElementById("submitButtonForm").click();
        }
        if (btnData?.postSubmitActionProp?.action === "newTab") {
            let route = createRoute({
                route: btnData.postSubmitActionProp.route,
                props: btnData?.postSubmitActionProp?.props,
                multiProps: btnData?.postSubmitActionProp?.multiProps,
                record: data,
                urlCode,
                params: { ...__urlData },
            });
            return window.open(route, '_blank');
        };

        if (btnData?.postSubmitActionProp?.action === 'reloadPage') {
            return window.location.reload();
        }
        if (btnData?.postSubmitActionProp?.action === 'route') {
            setZenModal({
                typ: "route",
                route: btnData?.postSubmitActionProp?.route,
                width: btnData?.postSubmitActionProp?.width,
                pageTitle: btnData?.postSubmitActionProp?.pageTitle
            });
            toggleModal({
                loading: false,
                show: true,
                data: {
                    urlData: __urlData
                },
                type: "route"
            });
            return;
        }
        if (btnData?.postSubmitActionProp?.action === 'smodal') {
            setZenModal({
                typ: "smodal",
                ...btnData?.postSubmitActionProp
            });
            toggleModal({
                loading: false,
                show: true,
                data: {
                    urlData: __urlData
                },
                type: 'smodal'
            });
            return;
        };
        if (btnData?.postSubmitActionProp?.api) {
            setZenModal({
                typ: btnData?.postSubmitActionProp?.action,
                ...btnData?.postSubmitActionProp
            });
            toggleModal({ show: true, loading: true, type: btnData?.postSubmitActionProp?.action });
            liracrypt.get(`${btnData?.postSubmitActionProp?.api}`, __urlData).then(response => {
                toggleModal({
                    show: true,
                    data: (btnData?.postSubmitActionProp?.action === 'image' && response?.data?.isSuccess === false) ? noImg : response?.data?.data,
                    loading: false,
                    type: btnData?.postSubmitActionProp?.action
                })
            });
            return;
        }
        finalAction(btnData?.postSubmitActionProp?.action, response)
    };

    const openPopupModal = (button) => {
        setIsHModalVisible(true);
        setAction({ edit: button.popUpModalProp });
    };

    const onFinish = ({ button }) => {
        if (button?.submitFormDataProp?.method === 'POST') {
            let postData = { ...searchParams, ...urlData, ...button?.submitFormDataProp.params };
            // postData.seldocs = selectedRowData;
            // if (button?.submitFormDataProp?.sendAllData) {
            //     postData = { ...postData, allData: tblConfig.data };
            // }
            liracrypt.post(button?.submitFormDataProp.api, postData).then(response => {
                notification.success({ message: response.data.message });
                onResponse({ button, response })
            })
                .catch(err => {
                    notification.error({
                        message: 'Something went wrong'
                    })
                })
        };
        if (button?.submitFormDataProp?.method === 'PATCH') {
            let postData = { ...searchParams, ...urlData, ...button?.submitFormDataProp.params };
            // if (button?.submitFormDataProp?.sendAllData) {
            //     postData = { ...postData, allData: tblConfig.data };
            // }
            liracrypt.patch(button?.submitFormDataProp.api, postData).then(response => {
                notification.success({ message: response.data.message });
                onResponse({ button, response })
            })
                .catch(err => {
                    notification.error({
                        message: 'Something went wrong'
                    })
                })
        };

    }

    const checkItemInBag = (item) => {
        let itemInBag = selectedItems.find(x => x._id === item._id);
        if (itemInBag) return true;
        return false;
    }

    const getMenu = (record) => {
        return (
            <>
                <Menu theme="dark">
                    <Menu.Item key={'edit'}>
                        <Button
                            style={{
                                marginBottom: "0",
                                backgroundColor: "#1777ff",
                                width: "100%",
                                color: "#ffffff",
                                fontWeight: "600",
                                borderRadius: "5px",
                                border: "0",
                            }}
                            onClick={() => onColumnClick(record, config?.ham?.edit)}
                        >
                            Edit
                        </Button>
                    </Menu.Item>
                    <Menu.Item key={'delete'}>
                        <Button
                            style={{
                                marginBottom: "0",
                                backgroundColor: "red",
                                width: "100%",
                                color: "#fff",
                                fontWeight: "600",
                                borderRadius: "5px",
                                border: "0",
                            }}
                            onClick={() => onColumnClick(record, config?.ham?.delete)}
                        >
                            Delete
                        </Button>
                    </Menu.Item>
                </Menu>
            </>
        );
    };

    const dragEndTest = (result) => {
        if (!result.destination) return;
        if(result.destination.index === result.source.index) return;
        const updatedItems = Array.from(items);
        const [reorderedItem] = updatedItems.splice(result.source.index, 1);
        updatedItems.splice(result.destination.index, 0, reorderedItem);
        liracrypt.patch(config?.api || '/test', { ...urlData, ...config?.params, items: updatedItems })
            .then(({ data }) => {
                if (data.isSuccess) {
                    message.success(data.message || 'Successfull');
                    setItems(data.data);
                    setConfig(data.config);

                } else {
                    message.error(data.message || 'Error');
                }
            }).catch(err => {
                ApiErrorComp();
            })
    }

    const sortableList = (
        <div className="sortable-list" style={{ ...config?.outerContainerStyle }}>
            {
                selectedItems.length > 1 ?
                    <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%', marginBottom: 20 }}>
                        <Button ghost={true} type="primary" style={{ marginRight: 20 }} onClick={groupItems}>
                            Group Plans
                        </Button>
                    </div> : <></>
            }
            <DragDropContext enableDefaultSensors={config?.isDraggable} onDragEnd={dragEndTest}>
                <Droppable droppableId="characters">
                    {(provided) => (
                        <ul className='lira-sortable-list' {...provided.droppableProps} ref={provided.innerRef}>
                            {items.map((item, indx) => (
                                <Draggable key={item.doc._id} draggableId={item.doc._id} index={indx}>
                                    {(provided) => (
                                        <li
                                            onClick={(e) => selectItem(e, item)}
                                            // className={`item ${item === draggingItem ? 'dragging' : ''} ${checkItemInBag(item) ? 'item-selected' : ''}`}
                                            ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}
                                        >
                                            <div style={config?.containerConfig[item.containerConfig]}>
                                                <Row style={{ position: 'absolute', top: 0, right: 10, zIndex: '100' }}>
                                                    <Col span={12}>
                                                    </Col>
                                                    <Col span={12}>
                                                        <Dropdown overlay={getMenu(item)} trigger={["click"]}>
                                                            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                                {/* <Button type="link" icon={
                                            <DashOutlined />}>{''}
                                        </Button> */}
                                                                <DashOutlined style={{ cursor: 'pointer' }} />
                                                            </div>
                                                        </Dropdown>
                                                    </Col>
                                                </Row>

                                                {/* <MultiText data={item.data} /> */}
                                                <MultiTextDynamic data={config?.blockConfig[item.blockConfig]} record={item.doc} />
                                            </div>

                                        </li>
                                    )}

                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </ul>
                    )}
                </Droppable>
            </DragDropContext>

        </div>
    )

    useEffect(() => {
        if (data) return setItems(data), setConfig(pageConfig), setPageLoading(false);
        setPageLoading(true);
        getData();
    }, []);

    const handleDrop = (e, targetItem) => {
        if (!draggingItem) return;

        const currentIndex = items.indexOf(draggingItem);
        const targetIndex = items.indexOf(targetItem);
        if (currentIndex === targetIndex) return;
        if (currentIndex !== -1 && targetIndex !== -1) {
            const updatedItems = [...items];
            updatedItems.splice(currentIndex, 1);
            updatedItems.splice(targetIndex, 0, draggingItem);
            liracrypt.patch(config?.api || '/test', { ...urlData, ...config?.params, items: updatedItems })
                .then(({ data }) => {
                    if (data.isSuccess) {
                        message.success(data.message || 'Successfull');
                        setItems(data.data);
                        setConfig(data.config);

                    } else {
                        message.error(data.message || 'Error');
                    }
                }).catch(err => {
                    ApiErrorComp();
                })

        }
    };

    return (
        <>
            {/* <SessionError loginError={loginError} /> */}
            <div className={''} style={{ display: 'flex', justifyContent: 'center' }}>
                {
                    pageLoading ?
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignContent: 'center',
                            alignItems: 'center',
                            width: '100%'
                        }}>
                            <Spin indicator={<LoadingOutlined style={{ fontSize: 80 }} spin />} />
                        </div> :
                        <>
                            <HModal
                                submitBtnId={'submitBtnModal'}
                                preventSubmitBtnClick={false}
                                onResponse={onResponse}
                                isModalVisible={isHModalVisible}
                                setIsModalVisible={setIsHModalVisible}
                                modalMethod={"edit"}
                                action={action}
                                modalData={null}
                                extraData={{ ...urlData }}
                            />
                            {
                                items.length ?
                                    sortableList :
                                    <p style={{ marginTop: 10, marginBottom: 0, color: '#9c9c9c', fontSize: 35, fontWeight: 'bold' }}>No Data Found!!</p>
                            }
                        </>
                }
                <ZenModal modal={modal} toggleModal={toggleModal} zenModal={zenModal} smodalCallback={({ data }) => onEditFinish(data)} />

            </div>
            {config?.footerButtons && (
                Object.keys(config?.footerButtons).map((btn, index) => {
                    const button = config?.footerButtons[btn];
                    if (button?.buttonProp?.visible) {
                        return (
                            <div key={index} style={{ marginTop: 20 }}>
                                <FooterButtons
                                    downloadDocs={downloadDocs}
                                    onFinish={onFinish}
                                    postSubmitAction={onResponse}
                                    openPopupModal={openPopupModal}
                                    button={button}
                                    setSelectedButton={setSelectedButton}
                                    form={null}
                                    label={button?.buttonProp?.label}
                                    type={button?.buttonProp?.type}
                                    disabled={!button?.buttonProp?.enable}
                                    confirmationPopUp={button?.buttonProp?.confirmationPopUp ? button?.confirmationPopUpProp : undefined}
                                    submitFormData={button?.submitFormDataProp}
                                />
                            </div>
                        )
                    }
                })
            )}

        </>

    );
};

export default SortableList;
